<template>
  <div>
    <div class="container">
      <div class="col-lg-12" style="padding: 0;">
        <filter-options
          v-bind:pageTitle="pageTitle"
          v-bind:filterItems="filterItems"
          v-on:filter-updated="filterSalesGroup"
        />
      </div>

      <div style="margin-top: 8px;">
        <b-table
          responsive
          show-empty
          hover
          :empty-text="$t('no_sales_groups_were_found')"
          ref="table"
          :busy.sync="isBusy"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :current-page="currentPage"
          :per-page="perPage"
          :items="salesGroupOverviewProvider"
          :fields="fields"
          @row-clicked="rowClicked"
          @sort-changed="sortingChanged"
        >
          <template v-slot:table-busy>
            <div style="height: 32px;">
              <div class="mb-3" style="color: #18385f; position: absolute; left: 50%;">
                <b-spinner></b-spinner>
              </div>
            </div>
          </template>
        </b-table>

        <div class="row" style="text-align: left;">
          <div class="col-sm-6 offset-sm-3">
            <b-pagination
              v-if="totalRows > 0"
              align="center"
              ref="bottomPagination"
              label-prev-page="first"
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              class="my-0"
              style="margin-top: 10px !important"
            />
          </div>

          <div class="col-sm-3">
            <div class="form-group row" style="margin-top: 10px;">
              <label
                for="inputPassword"
                class="col-sm-7 col-form-label text-right"
              >{{ $t('lines_per_page') }}</label>
              <div class="col-sm-5">
                <b-form-select
                  :options="pageOptions"
                  v-model="perPage"
                  :change="rowsPerPageChange()"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { odata } from './../../mixins/odata.js';
import { grid } from './../../mixins/grid.js';
import FilterOptions from '@/components/filter/FilterOptions.vue';
import { bus } from './../../main.js';

export default {
  name: 'SalesGroupOverview',
  mixins: [odata, grid],
  components: {
    filterOptions: FilterOptions
  },
  data: function() {
    return {
      filterItems: getFilterDefinition(this),
      pageTitle: 'customer_group_overview',
      filter: this.getFilter(this, 'sg-filter').filterString,
      isBusy: false,
      sortBy: this.getSortBy(this, 'sg-sortBy', 'salesGroupName'),
      sortDesc: this.getSortDesc(this, 'sg-sortDesc', false),
      fields: getTableFields(this),
      totalRows: 0,
      currentPage: this.getCurrentPage(this, 'sg-currentPage', 1),
      perPage: this.getPerPage(this, 'sg-perPage', calculateRowsOnScreen()),
      pageOptions: this.getRowsPerPageOptions(calculateRowsOnScreen())
    };
  },
  methods: {
    filterSalesGroup(filters) {
      var filterObject = {
        filterString: '',
        items: []
      };

      this.currentPage = 1;
      this.setCurrentPage(this, 'sg-currentPage', 1);

      for (let i = 0; i < filters.length; ++i) {
        let filter = filters[i];
        if (filter.value) {
          var item = {
            id: filter.id,
            value: filter.value
          };

          filterObject.items.push(item);
        }
      }

      this.filter = this.getFilterString(filters);

      filterObject.filterString = this.filter;

      var jsonItems = JSON.stringify(filterObject);

      this.setFilter(this, 'sg-filter', jsonItems);

      var self = this;

      setTimeout(function() {
        self.$refs.table.refresh();
      }, 500);
    },
    sortingChanged(ctx) {
      ctx.currentPage = 1;
      this.setCurrentPage(this, 'sg-currentPage', 1);
    },
    rowClicked(item, index, event) {
      this.$router.push({
        name: 'sales-group-detail',
        params: {
          companyId: item.companyId,
          salesGroupId: item.salesGroupId
        }
      });
    },
    salesGroupOverviewProvider(ctx) {
      var companyId = this.$route.params.id;

      // add fixed filter
      var filter = '';
      if (this.filter === '') {
        filter =
          "&$filter=(contains(toLower(companyId),toLower('" +
          companyId +
          "')))";
      } else {
        filter =
          this.filter +
          "and(contains(toLower(companyId),toLower('" +
          companyId +
          "')))";
      }

      var url = this.getServiceUr(
        'salesGroups',
        ctx,
        filter,
        this.generateOdataOrderByConditionString(
          ctx.sortBy,
          ctx.sortDesc,
          'dashboard'
        )
      );

      this.setSortBy(this, 'sg-sortBy', ctx.sortBy);
      this.setSortDesc(this, 'sg-sortDesc', ctx.sortDesc);
      this.setCurrentPage(this, 'sg-currentPage', ctx.currentPage);

      let promise = this.$axios.get(url);

      return promise
        .then(data => {
          const items = data.data.value;

          this.totalRows = data.data.count;

          this.currentPage = this.getCurrentPage(this, 'sg-currentPage', 1);

          return items;
        })
        .catch(error => {
          console.log(error);

          return [];
        });
    },
    changeLanguageHandler() {
      this.fields = getTableFields(this);
      this.$refs.table.refresh();
    },
    rowsPerPageChange: function() {
      this.setPerPage(this, 'sg-perPage', this.perPage);
    }
  },
  created() {
    bus.$on('languageChanged', this.changeLanguageHandler);
  },
  beforeDestroy() {
    bus.$off('languageChanged', this.changeLanguageHandler);
  }
};

function calculateRowsOnScreen() {
  var tableHeight = window.innerHeight - 300;

  var maxRows = tableHeight / 50;

  if (maxRows < 3) {
    return 5;
  }

  return Math.floor(maxRows);
}

function getFilterDefinition(context) {
  var filter = context.getFilter(context, 'sg-filter');

  const filterDefinition = [{ id: 'salesGroupName', value: '', type: 'input' }];

  filter.items.forEach(item => {
    filterDefinition.forEach(filter => {
      if (item.id === filter.id) {
        filter.value = item.value;
      }
    });
  });

  return filterDefinition;
}

function getTableFields(context) {
  return [
    {
      key: 'salesGroupId',
      label: 'Id',
      sortable: true,
      thClass: 'tr-left',
      tdClass: 'tr-left',
      class: 'tr-pointer'
    },
    {
      key: 'salesGroupName',
      label: context.$t('customer'),
      sortable: true,
      thClass: 'tr-left',
      tdClass: 'tr-left',
      class: 'tr-pointer'
    }
  ];
}
</script>

<style>
table.b-table > thead > tr > th.sorting:focus {
  outline: none !important;
}
.page-item.active .page-link {
  background-color: #18385f;
  border-color: #18385f;
}
.page-link:focus {
  box-shadow: none;
}
</style>
